import { Store, StoreType } from '@extTypes/api/customily/user';

export const getStoreType = (shop: string, stores: Store[]) => stores.find((s) => s.Url === shop)?.Type;

export const isStoreOfType = (shop: string, stores: Store[], storeType: StoreType) => {
    return stores.some((s) => s.Url === shop && s.Type === storeType);
};

export const isWooCommerceStore = (shop: string, stores: Store[]) => {
    const store = stores.find((s) => {
        return s.Url === shop;
    });
    return store && store.Type === StoreType.WooCommerce;
};

export const hasWooCommerceStores = (stores: Store[]) => {
    return stores.some((s) => s.Type === StoreType.WooCommerce);
};

export const isEtsyStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Etsy);
};

export const isCustomStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Custom);
};

export const isShoplazzaStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Shoplazza);
};

export const isAmazonStore = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Amazon);
};

export const isShopify = (shop: string, stores: Store[]) => {
    return isStoreOfType(shop, stores, StoreType.Shopify);
};
